import { InputText } from 'primereact/inputtext';
import './App.css';
import { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import axios from 'axios';
import { useNavigate, useSearchParams } from "react-router-dom";
import img_broken from './broken.png';
import { ProgressSpinner } from 'primereact/progressspinner';

function ScreenLogin() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const [token, setToken] = useState('');
    const [step, setStep] = useState('input');

    function authenticateDevice(token) {
        setStep('loading');

        axios.post(
            process.env.REACT_APP_API_HOST + '/device/auth/',
            {
                token: token
            }
        ).then(
            (response) => {
                localStorage.setItem('device_id', response.data.device_id);
                localStorage.setItem('device_token', response.data.device_token)
                setTimeout(
                    () => {
                        navigate('/screen/login/success/');
                    },
                    1000,
                )
            }
        ).catch(
            (error) => {
                setTimeout(
                    () => {
                        setStep('error');
                    },
                    1000,
                )
            }
        )
    }

    useEffect(
        () => {
            const token = searchParams.get('token');
            if (!token) {
                return;
            }
            authenticateDevice(token);
        },
        [],
    )

    return (
        <div align='center'>
            <div
                className='standard-box3'
                style={{
                    marginTop: '2em',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                {
                    step == 'input' &&
                    <div align='center'>
                        <h1>
                            Enter the device token:
                        </h1>
                        <InputText
                            value={token}
                            onChange={(e) => setToken(e.target.value)}
                            placeholder='enter token'
                            className='screen-login-password'
                            type='password'
                        />
                        <div style={{ marginTop: '1em' }}>
                            <Button
                                severity='success'
                                label='Continue'
                                onClick={() => authenticateDevice(token)}
                                // disabled={token == ''}
                            />
                        </div>
                    </div>
                }
                {
                    step == 'error' &&
                    <div align='center'>
                        <img src={img_broken} width={256} />
                        <h1>
                            Something went wrong.
                        </h1>
                        <Button
                            label='Try again'
                            onClick={() => setStep('input')}
                        />
                    </div>
                }
                {
                    step == 'loading' &&
                    <div align='center'>
                        <ProgressSpinner />
                    </div>
                }
            </div>
        </div>
    );
}

export default ScreenLogin;